import Mutations from '../../odata/mutations';

export default { ...new Mutations('salesOrderLine'), ...new Mutations('salesOrderLines') };
